import * as _ from 'lodash'
import IModel from "~/interfaces/modelInterfaces";
import ElementHandler from "~/services/elementHandler";
import Vue from "vue";
import PropertySection from "~/models/objectModels/propertySection";
import {ArrayHelper} from "~/helpers/arrayHelper";
import ObjectModel from "~/models/objectModel";
import {RegexHelper} from "~/helpers/regexHelper";
import ObjectModelProperty from "~/models/objectModelProperties/objectModelProperty";

export default class PropertyElementHandler<T extends IModel = any> extends ElementHandler {

  move(elementId: string, parentId: string, newPosition: number): void {
    const element = this.model.findInProp(this.collectionArrayKey, elementId);
    const oldParent = element.property_section_client_id ?
      this.model.findInProp('propertySectionsArray', element.property_section_client_id) : element.parent
    const newParent = this.model.findInPropOfType(this.collectionArrayKey, this.containerClass, parentId) ||
      this.model.findInProp('propertySectionsArray', parentId)

    if (newParent instanceof PropertySection) {
      element.property_section_client_id = newParent.client_id
    } else {
      element.property_section_client_id = null
    }

    element.sort_order = newPosition
    if (oldParent !== newParent) {
      // this fixes the .sort_order of the elements on the previous parent,
      // kind of like a scoped .recalculateElementPositions()
      this.updateElementPositions(oldParent, element, Infinity);
    }
    this.updateElementPositions(newParent, element, newPosition);

    this.model.rootModel.saveChangesToStore();
  }

  updateElementPositions(parent, movedElement, position: number) {
    if (parent instanceof ObjectModelProperty) {
      super.updateElementPositions(parent, movedElement, position)
      return
    }

    let siblings

    if (parent instanceof ObjectModel) {
      siblings = parent.objectModelPropertiesArray.filter((p) => {
        return !p.property_section_client_id
      })
      siblings = siblings.concat(parent.propertySectionsArray)
    } else if (parent instanceof PropertySection) {
      siblings = movedElement.parent.objectModelPropertiesArray.filter((p) => {
        return p.property_section_client_id === parent.client_id
      })
    } else {
      throw new Error('invalid parent')
    }

    ArrayHelper.updatePositionsByProp(siblings, movedElement, position, 'sort_order');
  }

  lastSortOrder(): number {
    return this.model.nextSortOrderFor('object_model_properties') - 1
  }

  recalculateElementPositions() {
    // .property_section_client_id could be either undefined or null
    const propertyByPropertySection = _.groupBy(this.model[this.collectionArrayKey], (p) => p.property_section_client_id || 'none')

    _.forOwn(propertyByPropertySection, (properties, propertySectionClientId) => {
      let siblings = properties

      if (propertySectionClientId === 'none') {
        siblings = siblings.concat(this.model.propertySectionsArray)
      }

      siblings.sort((a, b) => a.sort_order - b.sort_order)
        .forEach((element, i) => {
          element.sort_order = i;
        });
    })
  }
}
